import { useSuspenseQuery } from '@tanstack/react-query';

// Mock data fetching function for development/testing
function fetchMockData(key: string): Promise<string> {
  return new Promise((resolve) => {
    console.log(`fetching:${key}`);
    setTimeout(() => resolve(`data for ${key}`), 500 + Math.random() * 500);
  });
}

export function useMockData(key: string, staleTime = 0) {
  const { data, isLoading } = useSuspenseQuery({
    queryKey: [key],
    queryFn: () => fetchMockData(key),
    staleTime,
  });
  return isLoading ? null : data;
}
